function About() {
    return (
      <div className="py-5 bg-light">
        <div className="container text-center">
          <h2 className="mb-4">Hakkımızda</h2>
          <p className="lead">
            Trustlife kliniği olarak modern tıp teknolojilerini kullanarak her hastamıza özel çözümler sunuyoruz. 
          </p>
        </div>
      </div>
    );
  }
  
  export default About;